import React, { useState, useEffect } from 'react';
import Hero from '../components/Hero';
import DemoVideo from '../components/DemoVideo';
import ValueProps from '../components/ValueProps';
import TargetAudience from '../components/TargetAudience';
import WaitlistForm from '../components/WaitlistForm';
import Footer from '../components/Footer';
import Header from '../components/Header';

const Home = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0e1a] text-gray-100">
      <Header />
      <main className={`transition-opacity duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
        <Hero />
        <DemoVideo />
        <ValueProps />
        <TargetAudience />
        <WaitlistForm />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
